module.exports = __webpack_public_path__ + "0d3034b7c689d7f52c7de8fb96f72385.svg";